import React, { useState } from 'react';
import { Tv } from 'lucide-react';

export const ChannelLogo = ({ channel, testId }) => {
  const [failed, setFailed] = useState(false);
  return (
    <span className="client-channel-logo" data-testid={testId}>
      {channel.logo_url && !failed ? (
        <img src={channel.logo_url} alt={channel.name} loading="lazy" onError={() => setFailed(true)} />
      ) : <Tv aria-hidden="true" />}
    </span>
  );
};